// our-landing page slider
$('.multi_images').slick({
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots:false,
  prevArrow:'<div class="slick-prev slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0716/9903/8484/files/Stroke-1_84073fff-1637-474e-a828-8a8aa518fdf9.png?v=1677657356" class="slider-left-arrow"></div>',
  nextArrow:'<div class="slick-next slick-arrow"><img src="//cdn.shopify.com/s/files/1/0716/9903/8484/files/Stroke-1.png?v=1677577333" class="slider-right-arrow"></div>',
  // autoplay:true,
  // adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
       arrows:false,
        dots:true,
      }
    },
  ]
});

 // $('.redirect_button a,.custom_button a').click(function(e) {
 //    e.preventDefault();
 //    $('html, body').animate({
 //      scrollTop: $("#custom_bundle_section").offset().top
 //    }, 1000)
 //  });
